import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500">按题材快速找到想看的漫画，总有一个类型适合你</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200/60 transition-all cursor-pointer text-center"
            >
              <div className={`w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl ${item.color} transition-transform group-hover:scale-110`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-sm mb-1">{item.name}</h3>
              <p className="text-xs text-foreground-500">{item.count}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}